<div id="'divChildTemplate'+fieldName" class="divChildTemplate child-template-class label-static {{disabled ? 'disable-element' : ''}}">
    <mat-label class="{{componentDefinition.mandatory ? 'mandatory' : ''}} ">{{label}}</mat-label>
    <label *ngIf="isProcessing" class="label-truncation  control-label" style="margin-top: 4px;font-weight: bold;"> - Processing Version {{totalVersion}}...</label>
    <div style="clear:both;"></div>
    <!-- <button [id]="'btnTableReload'+fieldName+key" style="display:none;" (click)="eventReloadAuditTable()">Trigger Table Reload</button> -->
    <div class="datatable-container" *ngIf="!isHasTargetTableComponent">
        <div class="dataTable-header">
            <div class="mdl-cell mdl-cell--12-col">
              <div class="toolbar pageLength"><span class="lenLabelShow">Show</span>
                <mat-select
                  panelClass="pageLengthMenu"
                  [(ngModel)]="rowsPerPage"
                  (valueChange)="selectPageLengthChange($event)"
                  style="width: 50px;text-align: center;font-size: 12px;line-height: 40px;"
                >
                  <mat-option *ngFor="let length of lengthMenu" [value]="length" >
                    {{length}}
                  </mat-option>
                </mat-select>
                <span class="lenLabel" style="margin-left:5px;">Entries</span>
              </div>

              <div id="searchBox" class="toolbar searchBox">
                <span class="lenLabel search">Search</span>
                <input class="searchBoxInput" type="text" id="searchBoxInput_{{fieldName}}_{{key}}" (input)="search($event)"
                       placeholder="Search...">
              </div>

            </div>
          </div>
         <div class="dataTable-content">
            <table #dataTable id="{{fieldName}}" class="dataTable display no-wrap {{wrapText}}" width="100%"></table>
         </div>
    </div>

    <!-- Button trigger modal -->
    <button type="button" [id]="'btnTriggerModalPublic'+fieldName+key" style="display:none;" (click)="eventDoubleClickRowValue()">Trigger click Row</button>
     <!-- Modal -->
    <div class="modal fade" id="idOpenModalVersionComparison" tabindex="-1" role="dialog"
         aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header bg-info text-white">
                    <h5 class="modal-title" id="exampleModalLabel">Document Version Difference</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div id="divIdChangesRec" style="width: 100%;">
                        <div class="card">
                            <div class="card-body">
                                <h6 class="card-title"><a>Initial Value</a></h6>
                           <p class="card-text" style="font-size:13px;word-break: break-all;" id="idElemObjectChanges" [innerHTML]="initialValueDisplay"></p>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-body">
                                <h6 class="card-title"><a>New Value</a></h6>
                               <p class="card-text" style="font-size:13px;word-break: break-all;" id="idElemTypeChanges" [innerHTML]="newValueDisplay"></p>
                            </div>
                        </div>
                    </div>

                    <div #divDiffContainer class="diff-container-audit-table"></div>
                </div>
                <div class="modal-footer" style="padding-top: 10px;padding-right: 23px;padding-bottom: 10px;">
                    <button type="button" class="btn btn-primary btn-raised" data-dismiss="modal">Close</button>
                    <!-- <button type="button" class="btn btn-secondary btn-raised"  style="display:none" data-dismiss="modal">Ok</button> : no use -->
                </div>
            </div>
        </div>
    </div>
    <!--End Modal -->
    
</div>
<ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
